import { Routes, RouterModule } from '@angular/router';
import { RoutePlannerComponent } from '../route-planner/components/route-planner/route-planner.component';
import { NgModule } from '@angular/core';
import { TrafficNewsComponent } from '../traffic-news/components/traffic-news/traffic-news.component';
import { MapsHotelsComponent } from '../maps-hotels/components/maps-hotels/maps-hotels.component';
import { AARouterURL } from './enums/routing.enum';
import { NavComponent } from './components/app-navigation/nav.component';
import { RoutePlannerPrintViewComponent } from '../route-planner/components/route-planner-print-view/route-planner-print-view.component';
import { MapPrintPreviewComponent } from '../maps-hotels/components/map-print-preview/map-print-preview.component';
import { MobileNavigationComponent } from './components/mobile-navigation/mobile-navigation.component';
import { BrowserModule } from '@angular/platform-browser';

const routes: Routes = [
  { path: '', redirectTo: `/${AARouterURL.ROUTE_PLANNER}`, pathMatch: 'full' },
  {
    path: AARouterURL.ROUTE_PLANNER,
    component: RoutePlannerComponent,
    data: {
      title: 'Route Planner | Directions, traffic and maps | AA',
      description: `Use AA Route Planner to get directions. Find routes from a street, postcode, town,
      city or landmark to your destination. With maps, times, distance and miles.`,
      pageTitle: 'Route planner'
    }
  },
  {
    path: AARouterURL.PRINT_PREVIEW,
    component: RoutePlannerPrintViewComponent,
    outlet: AARouterURL.OUTLET_PRINT
  },
  {
    path: AARouterURL.TRAFFIC_NEWS,
    component: TrafficNewsComponent,
    data: {
      title: 'Traffic news | Live reports from AA Roadwatch | AA',
      description: `Live traffic news, 24 hours a day, from AA Roadwatch.
      Call 84322 - 'theAA' on your mobile or 0906 88 84322 from a land line for the latest travel news.`,
      pageTitle: 'Traffic news'
    }
  },
  {
    path: `${AARouterURL.TRAFFIC_NEWS}/:${AARouterURL._LOCATION}`,
    component: TrafficNewsComponent,
    data: {
      title: 'Traffic news{LOCATION}| Live reports from AA Roadwatch | AA',
      description: `Live traffic news{LOCATION}, 24 hours a day, from AA Roadwatch.
      Call 84322 - 'theAA' on your mobile or 0906 88 84322 from a land line for the latest travel news.`,
      pageTitle: 'Traffic news'
    }
  },
  {
    path: AARouterURL.MAP_HOTELS,
    component: MapsHotelsComponent,
    data: {
      title: 'Maps | Routes, traffic and places of interest | AA',
      description: `Find a place by postcode, town or city, place of interest, sports venue, hospital, train station, airport, 
      tourist attraction. Show hotels, B&Bs and restaurants.`,
      pageTitle: 'Maps & AA Hotels'
    }
  },
  {
    path: AARouterURL.MAP_PRINT_PREVIEW,
    component: MapPrintPreviewComponent,
    outlet: AARouterURL.OUTLET_PRINT
  },
  {
    path: `${AARouterURL.MAP_HOTELS}/:${AARouterURL._LOCATION}`,
    component: MapsHotelsComponent,
    data: {
      title: 'Maps | Routes, traffic and places of interest | AA',
      description: `Find a place by postcode, town or city, place of interest, sports venue, hospital, train station, airport, 
      tourist attraction. Show hotels, B&Bs and restaurants.`,
      pageTitle: 'Maps & AA Hotels'
    }
  },
  { path: '**', redirectTo: `/${AARouterURL.ROUTE_PLANNER}` }
];


@NgModule({
  declarations: [NavComponent, MobileNavigationComponent],
  imports: [BrowserModule, RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule, NavComponent, MobileNavigationComponent],
})
export class AppRoutingModule {
  constructor() {
  }
}
